import { Module } from "vuex";
import * as firebase from "firebase/app";
import "firebase/firestore";
import router from "@/router";
import moment from "moment";

const guestbookModule: Module<any, any> = {
  namespaced: false,
  state: {
    guestbook: [],
    guestbookRules: [],
    familyHubMemberGuestbookVisits: []
  },

  mutations: {
    setGuestbook(state: any, payload: []) {
      state.guestbook = payload;
    },
    setGuestbookRules(state: any, payload: []) {
      state.guestbookRules = payload;
    },
    setCurrentGuestbookVisit(state: any, payload: []) {
      state.currentGuestbookVisit = payload;
    },
    setFamilyHubMemberGuestbookVisits(state: any, payload: []) {
      state.familyHubMemberGuestbookVisits = payload;
    }
  },

  actions: {
    async getGuestbook({ commit }) {
      const startdate = moment()
        .add(-1, "days")
        .toDate();
      const enddate = moment()
        .add(1, "days")
        .toDate();

      const calenderEvents = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("start", ">=", startdate);
      await calenderEvents.get().then(querySnapshot => {
        const resList = querySnapshot.docs.map(x => {
          const thisRes = x.data();
          thisRes.id = x.id;

          return {
            ...thisRes,
            start: thisRes.start.toDate(),
            end: thisRes.end.toDate()
          };
        });
        commit("setGuestbook", resList);
      });
    },
    async getGuestbookVisits({ commit }, { startDate, endDate }) {
      const calenderEvents = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("start", ">=", startDate)
        .where("start", "<=", endDate);

      await calenderEvents.get().then(querySnapshot => {
        const resList: Array<any> = [];

        console.log(querySnapshot.docs);
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          thisRes.id = x.id;
          thisRes.start = moment(thisRes.start.seconds * 1000).toDate();
          thisRes.end = moment(thisRes.end.seconds * 1000).toDate();
          if (thisRes.checkedInTime)
            thisRes.checkedInTime = moment(
              thisRes.checkedInTime.seconds * 1000
            ).toDate();
          if (thisRes.createdDateTime)
            thisRes.createdDateTime = moment(
              thisRes.createdDateTime.seconds * 1000
            ).toDate();
          resList.push(thisRes);
        });
        commit("setGuestbook", resList);
      });
    },
    async getGuestbookVisitsByFamilyHubMemberId({ commit }, familyHubMemberId) {

      const calenderEvents = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("familyHubMemberId", "==", familyHubMemberId);

      await calenderEvents.get().then(querySnapshot => {
        const resList: Array<any> = [];
        querySnapshot.docs.forEach(x => {
          const thisRes = x.data();
          thisRes.id = x.id;
          thisRes.start = moment(thisRes.start.seconds * 1000).toDate();
          thisRes.end = moment(thisRes.end.seconds * 1000).toDate();
          if (thisRes.checkedInTime)
            thisRes.checkedInTime = moment(
              thisRes.checkedInTime.seconds * 1000
            ).toDate();
          if (thisRes.createdDateTime)
            thisRes.createdDateTime = moment(
              thisRes.createdDateTime.seconds * 1000
            ).toDate();
          resList.push(thisRes);
        });
        commit("setFamilyHubMemberGuestbookVisits", resList);
      });
    },
    async getGuestbookVisit({ commit }, id) {
      const guestbookVisit = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .doc(id);
      await guestbookVisit.get().then(querySnapshot => {
        const currentGbV = querySnapshot.data();
        if (currentGbV != null) {
          currentGbV.id = querySnapshot.id;
          currentGbV.start = moment(currentGbV.start.seconds * 1000).toDate();
          currentGbV.end = moment(currentGbV.end.seconds * 1000).toDate();
          if (currentGbV.checkedInTime)
            currentGbV.checkedInTime = moment(
              currentGbV.checkedInTime.seconds * 1000
            ).toDate();
          if (currentGbV.createdDateTime)
            currentGbV.createdDateTime = moment(
              currentGbV.createdDateTime.seconds * 1000
            ).toDate();
          commit("setCurrentGuestbookVisit", currentGbV);
        }
      });
    },
    async deleteVisit({ commit }, { id, reason }) {
      console.log(id);

      firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .doc(id)
        .update({ cancelReason: reason })
        .then(querySnapshot => {
          firebase
            .firestore()
            .collection("guestbookFamilyVisits")
            .doc(id)
            .delete()
            .then(a => {
              -router.push("/guestbook");
            });
        });
    },

    async getGuestbookRules({ commit }) {
      const guestbookRules = firebase
        .firestore()
        .collection("guestbookRules")
        .doc(this.state.authModule.currentFacility);
      await guestbookRules.get().then(querySnapshot => {
        commit("setGuestbookRules", {
          ...querySnapshot.data(),
          start: querySnapshot.data()?.start ? querySnapshot.data()?.start : moment(new Date()).set({hour: 10, minute: 0}).format("HH:mm"),
          end: querySnapshot.data()?.end ? querySnapshot.data()?.end : moment(new Date()).set({hour: 18, minute: 0}).format("HH:mm"),
          lunchStart: querySnapshot.data()?.lunchStart ? moment(querySnapshot.data().lunchStart?.seconds * 1000).format("HH:mm") : null,
          lunchEnd: querySnapshot.data()?.lunchEnd ? moment(querySnapshot.data().lunchEnd?.seconds * 1000).format("HH:mm") : null,
        });
      });
    },

    async checkInVisitors({ dispatch, commit }, guesbookitem) {
      const visit = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .doc(guesbookitem.id);

      const completedDateTime = firebase.firestore.Timestamp.now();

      await visit
        .update({
          status: "checkedIn",
          facilityId: this.state.authModule.currentFacility,
          checkedInByStaffId: this.state.authModule.user.id,
          checkedInByStaffName: this.state.authModule.user.name,
          checkedInTime: completedDateTime,
          visitors: guesbookitem.visitors
        })
        .then(querySnapshot => {
          dispatch("getGuestbookVisit", guesbookitem.id);
        });
    },

    async updateVisit(
      { dispatch, commit },
      { guestbookitem, updateTime }
    ) {
      const visit = await firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .doc(guestbookitem.id);

      const guestbook = await firebase
        .firestore()
        .collection("guestbook")
        .doc(guestbookitem.id);

      guestbookitem.start = firebase.firestore.Timestamp.fromDate(
        new Date(guestbookitem.start)
      );
      guestbookitem.end = firebase.firestore.Timestamp.fromDate(
        new Date(guestbookitem.end)
      );

      await visit
        .update({
          start: guestbookitem.start,
          end: guestbookitem.end,
          visitType: guestbookitem.visitType,
          visitors: guestbookitem.visitors
        })
        .then(async querySnapshot => {
          await firebase
            .firestore()
            .collection("guestbook")
            .where("facilityId", "==", this.state.authModule.currentFacility)
            .where("guestbookFamilyVisitId", "==", guestbookitem.id)
            .get()
            .then(querySnapshot => {
              querySnapshot.docs.forEach(x => {
                firebase
                  .firestore()
                  .collection("guestbook")
                  .doc(x.id)
                  .update({
                    start: guestbookitem.start,
                    end: guestbookitem.end,
                    visitType: guestbookitem.visitType
                  })
                  .then(querySnapshot => {
                    dispatch("getGuestbookVisit", guestbookitem.id);
                  });
              });
            });
        });
    },

    async refuseEntry({ commit, dispatch }, guesbookitem) {
      const visit = firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .doc(guesbookitem.id);

      const completedDateTime = firebase.firestore.Timestamp.now();
      await visit.update({
        status: "refusedEntry",
        facilityId: this.state.authModule.currentFacility,
        refusedByStaffId: this.state.authModule.user.id,
        refusedByStaffName: this.state.authModule.user.name,
        refusedTime: completedDateTime,
        visitors: guesbookitem.visitors
      });

      dispatch("getGuestbookVisit", guesbookitem.id);
    },

    async updateGuestbookRules({ commit, dispatch }, guestbook) {

      return firebase
        .firestore()
        .collection("guestbookRules")
        .doc(this.state.authModule.currentFacility)
        .update(guestbook)
        .then(querySnapshot => {
          dispatch("getGuestbookRules");
        });
    },

    // async updateGuestbookVisit({ commit, dispatch }, visit) {
    //   firebase
    //     .firestore()
    //     .collection("guestbook")
    //     .doc(event.id)
    //     .update({
    //       status: visit.status,
    //       start: firebase.firestore.Timestamp.fromDate(
    //         new Date(event.start)
    //       ),
    //       end: firebase.firestore.Timestamp.fromDate(
    //         new Date(event.end)
    //       ),
    //       VideoLink: event.VideoLink ?? ""
    //     }).then((x) => dispatch("getGuestbookEvent", event.id));

    // },

    async bookVisit({ dispatch }, visit) {
      visit.facilityId = this.state.authModule.currentFacility;
      visit.isStaffBooked = true;
      visit.createdDateTime = firebase.firestore.Timestamp.fromDate(new Date());
      visit.start = firebase.firestore.Timestamp.fromDate(
        new Date(visit.start)
      );
      visit.end = firebase.firestore.Timestamp.fromDate(new Date(visit.end));
      visit.staffId = this.state.authModule.user.id;
      visit.staffName = this.state.authModule.user.name;

      await firebase
        .firestore()
        .collection("guestbookFamilyVisits")
        .add({ ...visit })
        .then(() => {
          dispatch("getGuestbook");
        });
    },
    async RejectGuestbookInvite({ dispatch }, id) {
      firebase
        .firestore()
        .collection("guestbook")
        .doc(id)
        .delete()
        .then(q => {
          dispatch("getGuestbook");
        });
    }
  }
};
export default guestbookModule;
